import useData, { DataType as _DataType, ZapType as _ZapType } from './useData';

export default useData;

export type DataType = _DataType;
export type ZapType = _ZapType;
